var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/navigation/arrow_forward_ios_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/navigation/arrow_forward_ios_24px_2",
    d: "M6.16406 20.1301L7.93406 21.9001L17.8341 12.0001L7.93406 2.1001L6.16406 3.8701L14.2941 12.0001L6.16406 20.1301H6.16406Z",
    fill: "#fad504"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 2,
    width: 12,
    height: 24
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/navigation/arrow_forward_ios_24px_3",
    d: "M6.16406 20.1301L7.93406 21.9001L17.8341 12.0001L7.93406 2.1001L6.16406 3.8701L14.2941 12.0001L6.16406 20.1301H6.16406Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForward);
export default __webpack_public_path__ + "static/media/arrow-forward.ee51d94b1178223c7bd2da8984df35d3.svg";
export { ForwardRef as ReactComponent };